define('formkit/view/block/answer.section.menu.view',['require','exports','module','underscore','../form/section/section.composite.view','../form/section/section.item.view','../../behavior/progressively.disclose.on.displayed.behavior'],function(require, exports, module) {
  var _                                        = require('underscore');
  var SectionCompositeView                     = require('../form/section/section.composite.view');
  var SectionItemView = require('../form/section/section.item.view');
  var ProgressivelyDiscloseOnDisplayedBehavior = require('../../behavior/progressively.disclose.on.displayed.behavior');


  var AnswerSectionCompositeView = SectionCompositeView.extend({

    options: _.extend({}, SectionCompositeView.prototype.options, {
      designable: false
    }),

    childView: SectionItemView.extend({
      behaviors: _.extend({}, SectionItemView.prototype.behaviors, {
        ProgressivelyDiscloseOnDisplayedBehavior: {
          behaviorClass: ProgressivelyDiscloseOnDisplayedBehavior
        }
      })
    }),

    initialize: function() {
      SectionCompositeView.prototype.initialize.apply(this, arguments);

      if (this.form) {
        this.collection = this.form.getTemplateModel().get('children')
      }
    }
  });

  module.exports = AnswerSectionCompositeView;
});

